import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { getMe } from "@/api/auth";
import { isApiError } from "@/api/errors";
import type { UserResponse } from "@/api/types";

export const CURRENT_USER_QUERY_KEY = ["currentUser"] as const;

/**
 * Loads the principal from GET /api/auth/me. 401 is a normal "no session"
 * state — we resolve to `null` so consumers can branch on it without try/catch.
 */
export function useCurrentUser(): UseQueryResult<UserResponse | null> {
  return useQuery<UserResponse | null>({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: async (): Promise<UserResponse | null> => {
      try {
        return await getMe();
      } catch (err) {
        if (isApiError(err) && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
